/**
 * @generated SignedSource<<88e4156fbe36394a7d917f860aa439ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorForm_rateByRoom$data = {
  readonly room: {
    readonly " $fragmentSpreads": FragmentRefs<"RoomNameWithCapacity_room">;
  };
  readonly roomRate: {
    readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorPriceBreakdown_roomRate">;
  } | null;
  readonly " $fragmentType": "RoomRatesTableRateEditorForm_rateByRoom";
};
export type RoomRatesTableRateEditorForm_rateByRoom$key = {
  readonly " $data"?: RoomRatesTableRateEditorForm_rateByRoom$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_rateByRoom">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditorForm_rateByRoom",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomNameWithCapacity_room"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoomRate",
      "kind": "LinkedField",
      "name": "roomRate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomRatesTableRateEditorPriceBreakdown_roomRate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RateByRoom",
  "abstractKey": null
};

(node as any).hash = "05f4d67d28d4874407d59a187841247c";

export default node;
